<template>
  <UModal
    :dismissible="false" 
    :close="{ onClick: () => emit('close') }"
    :ui="{ footer: 'justify-end' }"
  >
    <template #header>
      <VisuallyHidden>
        <DialogTitle>{{ t('components.highlights') }}</DialogTitle>
        <DialogDescription>Annotate a highlight</DialogDescription>
      </VisuallyHidden>

      <UButton
        id="highlightModalCloseBtn"
        :aria-label="t('components.close')"
        class="absolute top-1 end-2"
        variant="ghost"
        tabindex="-1" 
        @click="emit('close')"
      >
        <svg class="w-5 h-5">
            <use xlink:href="/icons/default-icons.svg#close" />
        </svg>
      </UButton>
    </template>

    <template #body>
      <UFormField label="Highlight Text" class="mb-3" :ui="{ label: 'block font-bold text-default'}">
        <div>{{ highlightText }}</div>
      </UFormField>
      <UFormField label="Note" class="mb-3" :ui="{ label: 'block font-bold text-default'}">
        <UTextarea v-model="note" class="w-full" />
      </UFormField>
      <UFormField>
        <input v-model="selectedColor" type="radio" name="highlight-color" value="#FFDD55" title="yellow" aria-label="highlight color yellow" style="display: inline-block;">
        <input v-model="selectedColor" type="radio" name="highlight-color" value="#FF8080" title="red" aria-label="highlight color red" style="display: inline-block;">
        <input v-model="selectedColor" type="radio" name="highlight-color" value="#AFE9DD" title="green" aria-label="highlight color green" style="display: inline-block;">
        <input v-model="selectedColor" type="radio" name="highlight-color" value="#80B3FF" title="blue" aria-label="highlight color blue" style="display: inline-block;">
      </UFormField>
    </template>

    <template #footer>
      <UButton 
        id="alertModalCustomCloseBtn"
        :label="t('components.close')" 
        variant="outline" 
        tabindex="-1" 
        @click="saveHighlight()">Save
      </UButton>
    </template>
    
  </UModal>
</template>

<script setup lang="ts">

// Reku-UI is the underlying UI for NuxtUI. 
// This import is required to include a DialogTitle and DialogDescription element which is an accessibility requirement.
import { DialogTitle, DialogDescription, VisuallyHidden } from 'reka-ui'
import type { ICirrusReaderHighlightData } from '../shared/CirrusReaderModel';

const { t } = useI18n();

const emit = defineEmits<{
  close: [highlight?: ICirrusReaderHighlightData]
}>()

const props = defineProps<{ 
  highlight: ICirrusReaderHighlightData,
}>();

const highlightText = ref(props.highlight.selectionText);
const note = ref(props.highlight.comment ?? '');
const selectedColor = ref(props.highlight.color ?? '#FFDD55');

const saveHighlight = () => {
  const highlight: ICirrusReaderHighlightData = {...props.highlight, color: selectedColor.value, comment: note.value}
  emit('close', highlight)
}
</script>

<style scoped>
input[type=radio][name="highlight-color"] {
  appearance: none;
  margin: 0;
  width: 40px;
  height: 40px;
  display: inline-block;
  border: 0;
  border-radius: 50%;
  margin-right: 10px;
}
input[type=radio][title="red"] {
  background-color: #FF8080;
}
input[type=radio][title="blue"] {
  background-color: #80B3FF;
}
input[type=radio][title="green"] {
  background-color: #AFE9DD;
}
input[type=radio][title="yellow"] {
  background-color: #FFDD55;
}
input[type=radio][name="highlight-color"]:checked {
  border: 2px solid rgba(54, 48, 54, 0.3);
}
</style>